import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { useTimeout } from './useTimeout';
/**
 * useState but the state returns to initialValue after a given amount of time from whenever setState is called
 * @param initialValue the initial value of the state - the value gets changed back to this after the amount of time given
 * @param time the amount of time in ms to wait to return back to initialValue
 */

export function useTemporaryState(initialValue) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var onReset = arguments.length > 2 ? arguments[2] : undefined;

  var _React$useState = React.useState(initialValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var onTimeout = React.useCallback(function () {
    setValue(initialValue);
    onReset === null || onReset === void 0 ? void 0 : onReset();
  }, [onReset, initialValue]);

  var _useTimeout = useTimeout(time, onTimeout),
      setTimeout = _useTimeout.set,
      clearTimeout = _useTimeout.clear;

  var set = React.useCallback(function (newValue) {
    setValue(newValue);
    setTimeout();
  }, [setTimeout]);
  var clear = React.useCallback(function () {
    setValue(initialValue);
    clearTimeout();
  }, [clearTimeout]);
  return [value, set, clear];
}